module.exports = __webpack_public_path__ + "img/nt110-00-81-1.asm.07ded5ba.jpg";